export default __webpack_public_path__ + "static/media/redhat.56fbc949.png";